import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  FormFeedback,
  Input,
  Button,
  ModalFooter,
  Label,
  FormGroup,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// import ParticlesAuth from "./ParticlesAuth";

//import images
import logoLight from "../../assets/images/logo-light.png";
import GoogleMapModal from "Components/Common/GoogleMapPopUp";
import { toast, ToastContainer } from "react-toastify";
import { getPlaceDetails, getPlaceLatLng } from "services/common/googlePlaces";
import { useDispatch, useSelector } from "react-redux";
// import { addNewLead } from "slices/thunks";

import OtpModal from "Components/Common/OtpModal";
import OtpSuccessModal from "Components/Common/OtpSuccess";
import { RootState } from "store";
import { createSelector } from "reselect";
// import { setOtpModal } from "slices/audit/reducer";
// import { } from "slices/audit/thunk";
import { setOtpModal } from "slices/form/reducer";
import { addNewLead, getClientData } from "slices/form/thunk";

import ParticlesAuth from "./ParticlesAuth";
import config from "config";

const BasicSignUp = () => {
  interface LeadFormValues {
    name: string;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    pannumber: string;
    address: string;
    latitude: string;
    longitude: string;
    pincode: string;
    state: string;
    district: string;
    city: string;
    service: string;
    // services:string[];
    // additional_info: string;
    // bank_name: string;
    // services: string;
    // service: string;
    // atbc_type: string;
    // aeps_type: string;
    // img: string;
  }
  document.title = "Add Lead";

  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const GOOGL_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || "";
  const [selectedCoords, setSelectedCoords] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [selectedPlace, setSelectedPlace] = useState<{ name: string }>({
    name: "",
  });
  const [shouldFetch, setShouldFetch] = useState(true);

  const [showDropdown, setShowDropdown] = useState(false);
  const [locationOptions, setLocationOptions] = useState<any[]>([]);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const servicesDropdownRef = useRef(null);
  const [loader, setLoader] = useState<boolean>(false);
  const [smsConsent, setSmsConsent] = useState(false);

  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const selectLeadState = (state: RootState) => state.Lead;

  const selectUserData = createSelector(selectLeadState, (lead) => ({
    isOpenState: lead?.isopen,
    clientId: lead?.client_id,
  }));

  const { isOpenState, clientId } = useSelector(selectUserData);
  console.log("isOpenState", isOpenState);
  console.log("open", open);
  console.log("clientId", clientId);

  const dispatch: any = useDispatch();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source")?.toLowerCase();


  const formik = useFormik<LeadFormValues>({
    enableReinitialize: true,
    initialValues: {
      name: "",
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      pannumber: "",
      address: "",
      latitude: "",
      longitude: "",
      pincode: "",
      state: "",
      district: "",
      city: "",
      service: "",
      // services:[]
      // additional_info: "",
      // bank_name: "",
      // services: "",
      // service: "",
      // atbc_type: "",
      // aeps_type: "",
      // img: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string()
        .matches(/^[A-Za-z\s]+$/, "Name can only contain alphabets and spaces")
        .required("Required"),
      lastname: Yup.string()
        .matches(/^[A-Za-z\s]+$/, "Name can only contain alphabets and spaces")
        .required("Required"),
      pannumber: Yup.string()
        .matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          "PAN must be in format: 5 uppercase letters, 4 digits, 1 uppercase letter (e.g. ABCDE1234F)"
        ),
        // .required("PAN number is required"),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
        .required("Required"),
      email: Yup.string()
        .email("Enter a valid email address")
        .required("Required"),

      address: Yup.string().required("Required"),
      service: Yup.string().required("Select a service"),
      // address: Yup.string()
      //   .required("Required")
      //   .matches(
      //     /^([^,]+,){2,}[^,]+$/,
      //     "Enter a complete address with at least 3 comma-separated parts"
      //   ),

      // latitude: Yup.string().required("Required"),
      // latitude: Yup.string()
      //   .required("Required")
      //   .matches(
      //     /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)(?<!\.\d{20,})$/,
      //     "Enter a valid latitude"
      //   ),

      // longitude: Yup.string()
      //   .required("Required")
      //   .matches(
      //     /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)(?<!\.\d{20,})$/,
      //     "Enter a valid longitude"
      //   ),

      state: Yup.string()
        .required("Required")
        .matches(/^[A-Za-z\s]+$/, "State must contain only letters and spaces"),

      // district: Yup.string()
      //   .required("Required")
      //   .matches(
      //     /^[A-Za-z\s]+$/,
      //     "District must contain only letters and spaces"
      //   ),

      city: Yup.string()
        .required("Required")
        .matches(/^[A-Za-z\s]+$/, "City must contain only letters and spaces"),
      // pincode: Yup.string()
      //   .required("Required")
      //   .matches(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit pincode"),
    }),

    onSubmit: (values: any) => {
      console.log("formik submit");
      console.log("formik values", values);
      const addleadData = {
        firstname: values.firstname,
        lastname: values.lastname,
        name: `${values.firstname} ${values.lastname}`,
        mobile: values.phone,
        email: values.email,
        pannumber: values.pannumber,
        address: values.address,
        latitude: values.latitude.toString(),
        longitude: values.longitude.toString(),
        state: values.state,
        district: values.district,
        city: values.city,
        pincode: values.pincode,
        services: values.service ? [values.service] : [""],
        bankname: "",
        bankcode: "",
        leadtype: "",
        service: "",
        ...(source ? { source } : {}),
      };
      setLoader(true) 
      dispatch(addNewLead(addleadData))
        .unwrap() // this unwraps the promise from createAsyncThunk
        .then(() => {
          // success
          setLoader(false);
        })   
        .catch((error: any) => {
        console.error("Error adding lead:", error);
        setLoader(false); // stop loader even on error
      });
      // setOpen(true);
      // resetForm()
    },
  });

    useEffect(() => {
    if (source === "billpay" || source === "finvesta") {
      // Set service when source is billpay
      formik.setFieldValue("service", "indonepalremittance");
    }
  }, [source]);

  const [addressInput, setAddressInput] = useState(formik.values.address || "");

  const handleSelectPlace = async (opt: any) => {
    try {
      setAddressInput(opt.text);
      formik.setFieldValue("address", opt.text);
      setShowDropdown(false);
      setShouldFetch(false);

      const placeDetails = await getPlaceDetails(opt.placeId);
      const { latitude, longitude } = placeDetails.location;

      const getComponent = (type: string) =>
        placeDetails.addressComponents?.find(
          (c: any) => Array.isArray(c.types) && c.types.includes(type)
        )?.longText || "";

      formik.setFieldValue("latitude", latitude.toString());
      formik.setFieldValue("longitude", longitude.toString());
      console.log("lattttt", latitude.tostring());
      formik.setFieldValue("city", getComponent("locality"));
      formik.setFieldValue(
        "state",
        getComponent("administrative_area_level_1")
      );
      formik.setFieldValue(
        "district",
        getComponent("administrative_area_level_2")
      );
      formik.setFieldValue("pincode", getComponent("postal_code"));
    } catch (error) {
      console.error("Error fetching place details:", error);
    }
  };
  const renderInput = (
    field: keyof LeadFormValues,
    label: string,
    placeholder?: string
  ) => (
    <div>
      <Label htmlFor={`${field}-field`} className="form-label">
        {label}
        {(field === "firstname" ||
          field === "lastname" ||
          field === "email" ||
          field === "phone") && <span style={{ color: "red" }}> *</span>}
      </Label>
      <Input
        id={`${field}-field`}
        name={field}
        className="form-control"
        placeholder={placeholder || `Enter ${label}`}
        type="text"
        value={formik.values[field]}
        onBlur={formik.handleBlur}
        invalid={!!(formik.touched[field] && formik.errors[field])}
        onChange={(e) => {
          const value = e.target.value;
          console.log("inside input");

          if (field === "firstname") {
            const valid = /^[A-Za-z\s]*$/;

            if (valid.test(value)) {
              formik.setFieldValue(field, value);
            }
          } else if (field === "lastname") {
            const valid = /^[A-Za-z\s]*$/;
            if (valid.test(value)) {
              formik.setFieldValue(field, value);
            }
          } else if (field === "phone") {
            const valid = /^[0-9]*$/;
            if (valid.test(value)) {
              formik.setFieldValue(field, value);
            }
          } else if (field === "email") {
            const valid = /^[a-zA-Z0-9@._-]*$/;
            if (valid.test(value)) {
              formik.setFieldValue(field, value);
            }
          } else if (field === "pincode") {
            const valid = /^[0-9]*$/;
            if (valid.test(value) && value.length <= 6) {
              formik.setFieldValue(field, value);
            }
          } else if (["state", "district", "city"].includes(field)) {
            // Allow all characters for editing, will translate to English before saving
            formik.setFieldValue(field, value);
            // } else if (["latitude", "longitude"].includes(field)) {
          } else if (field === "address") {
            // const valid = /^-?\d*\.?\d*$/;
            // if (valid.test(value)) {
            // }
            console.log("value", value.length);
            formik.setFieldValue(field, value);
            if (value.length > 2) {
              console.log("value", value.length);
              getPlaceLatLng(value)
                .then((options) => {
                  setLocationOptions(options);
                  setShowDropdown(true);
                })
                .catch((err) => {
                  console.error("Autocomplete error:", err);
                  setLocationOptions([]);
                  setShowDropdown(false);
                });
            } else {
              setLocationOptions([]);
              setShowDropdown(false);
            }
          } else {
            console.log("values of lat", value);
            formik.setFieldValue(field, value.toString());

            console.log("values of lat", value);
          }
        }}
      />

      {formik.touched[field] && formik.errors[field] && (
        <FormFeedback>{formik.errors[field]}</FormFeedback>
      )}
    </div>
  );

  useEffect(() => {
    const host = window.location.host;
    if (host) {
      dispatch(getClientData(host));
    }
  }, []);

  useEffect(() => {
    // On component load, try getting location
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        // Save lat/lng
        formik.setFieldValue("latitude", latitude.toString());
        formik.setFieldValue("longitude", longitude.toString());

        // Reverse geocode to get address details
        try {
          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGL_API_KEY}&language=en`
          );
          const data = await res.json();

          if (data.results && data.results[0]) {
            const address = data.results[0].formatted_address;
            formik.setFieldValue("address", address);

            // Extract parts (state, city, pincode, district)
            const components = data.results[0].address_components;
            const getComponent = (type: any) =>
              components.find((c: any) => c.types.includes(type))?.long_name ||
              "";

            formik.setFieldValue(
              "state",
              getComponent("administrative_area_level_1")
            );
            formik.setFieldValue("city", getComponent("locality"));
            formik.setFieldValue(
              "district",
              getComponent("administrative_area_level_2")
            );
            formik.setFieldValue("pincode", getComponent("postal_code"));
          }
        } catch (err) {
          console.error("Reverse geocoding failed", err);
          // toast.error
        }
      },
      (error) => {
        console.error("Location permission denied:", error);
      }
    );
  }, []);
  // useEffect(()=>{
  //   setOpen(isOpenState)
  // },[isOpenState])

  // const toggle = () => setOpen((prev) => !prev);
  const toggle = () => dispatch(setOtpModal());

  const onVerify = async (code: string) => {
    setBusy(true);
    setError("");
    // simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setBusy(false);

    if (code === "12345") {
      // alert("OTP Verified ✅");
      setShowModal(true);
      formik.resetForm();
      toggle();
    } else {
      setError("Invalid OTP, please try again");
    }
  };

  const [showModal, setShowModal] = useState<boolean>(false);

  const handleOtpVerify = () => {
    // OTP verification logic
    setShowModal(true);
  };

  const services = [
    { value: "cms", label: "CMS" },
    { value: "indonepalremittance", label: "Indo-Nepal Remittance" },
    { value: "aeps", label: "AEPS" },
    { value: "insurance", label: "Insurance" },
    { value: "rechargebillpayments", label: "Recharge & Bill Payments" },
    { value: "doorstepbanking", label: "Doorstep Banking" },
    { value: "allservices", label: "All Services" },
    { value: "psballiance", label: "PSB Alliance" },
    { value: "pancardutility", label: "PAN Card/Utility" },
    { value: "bbpsbillpaymentrecharge", label: "BBPS/Bill Payment/Recharge" },
    { value: "mutualfund", label: "Mutual Fund" },
    { value: "mmtcdg", label: "MMTC/DG" },
  ];

  const handleRedirect = () => {
    setShowModal(false);
    const url = config.google.GOOGLE_REDIRECT_API;
    window.location.href = url;
  };

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} />
      <ParticlesAuth>
        <div className="auth-page-content ">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      {/* <img src={logoLight} alt="" height="20" /> */}
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={8}>
                <Card className="mt-4 card-bg-fill">
                  <CardBody className="p-4">
                    {/* <div className="text-center mt-2">
                      <h5 className="text-primary">Create New Lead</h5>
                    </div> */}
                    <div className="p-2 mt-2">
                      <Form
                        onSubmit={(e) => {
                          console.log("values", formik.values);
                          e.preventDefault();
                          formik.handleSubmit();
                          // return false;
                        }}
                        className="needs-validation"
                        action="#"
                      >
                        <Row className="g-3 w-100">
                          <Col md={6}>
                            {renderInput("firstname", "First Name")}
                          </Col>
                          <Col md={6}>
                            {renderInput("lastname", "Last Name")}
                          </Col>
                          <Col md={6}>
                            {renderInput("phone", "Phone Number")}
                          </Col>
                          <Col md={6}>
                            {renderInput(
                              "pannumber",
                              "Pan",
                              "Enter Pan Number"
                            )}
                          </Col>
                          <Col md={6}>
                            {renderInput(
                              "email",
                              "Email Address",
                              "Enter your email address"
                            )}
                          </Col>
                          <Col lg={6} md={6} sm={12}>
                            <FormGroup>
                              <Label className="form-label">
                                Services<span style={{ color: "red" }}> *</span>
                              </Label>
                              <div ref={servicesDropdownRef}>
                                <ButtonGroup className="d-block w-100">
                                  <Dropdown
                                    isOpen={isServicesDropdownOpen}
                                    toggle={() => {}}
                                  >
                                    <DropdownToggle
                                      tag="button"
                                      type="button"
                                      className="btn btn-soft-primary w-100 text-start"
                                      onClick={() => {
                                        if (source !== "billpay" && source !== "finvesta") {
                                          setIsServicesDropdownOpen(!isServicesDropdownOpen);
                                          formik.setFieldTouched("service", true);
                                        }
                                      }}
                                    >
                                      {formik.values.service
                                        ? services.find(
                                            (s: any) =>
                                              s.value === formik.values.service
                                          )?.label
                                        : "Select Service"}
                                      <i className="mdi mdi-chevron-down float-end"></i>
                                    </DropdownToggle>

                                    <DropdownMenu
                                      className="w-100"
                                      style={{
                                        maxHeight: "220px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {services.map((service: any) => (
                                        <DropdownItem
                                          key={service.value}
                                          type="button"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            formik.setFieldValue(
                                              "service",
                                              service.value
                                            ); // set single value
                                            setIsServicesDropdownOpen(false); // close dropdown
                                          }}
                                          active={
                                            formik.values.service ===
                                            service.value
                                          } // highlight selected
                                        >
                                          {service.label}
                                        </DropdownItem>
                                      ))}
                                    </DropdownMenu>
                                  </Dropdown>
                                </ButtonGroup>
                                {formik.touched.service &&
                                  formik.errors.service && (
                                    <div className="invalid-feedback d-block">
                                      {formik.errors.service}
                                    </div>
                                  )}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row className="g-3 w-100 mt-1 mb-2">
                          <Col md={12} className="d-flex align-items-end">
                            <Button
                              color="outline-primary"
                              size="sm"
                              onClick={() => {
                                // Ask for location and open map modal
                                navigator.geolocation.getCurrentPosition(
                                  async (position) => {
                                    const coords = {
                                      lat: position.coords.latitude,
                                      lng: position.coords.longitude,
                                    };

                                    // Set initial coordinates
                                    setSelectedCoords(coords);
                                    setMapModalOpen(true);
                                  },
                                  (error) => {
                                    alert(
                                      "Please allow location access to pick from map."
                                    );
                                    console.error(
                                      "Location permission denied:",
                                      error
                                    );
                                  }
                                );
                              }}
                              className="d-flex align-items-center gap-2"
                            >
                              <i className="ri-map-pin-add-line fs-5"></i>
                              Choose Location
                            </Button>
                          </Col>
                        </Row>

                        <Row className="g-3 w-100 mb-2">
                          <Col>
                            {renderInput(
                              "address",
                              "Address",
                              "Start typing here..."
                            )}

                            {showDropdown && locationOptions.length > 0 && (
                              <div className="dropdown-menu show w-100">
                                {locationOptions.slice(0, 5).map((opt, idx) => (
                                  <li
                                    key={idx}
                                    className="dropdown-item text-wrap py-1 px-2 cursor-pointer lh-sm fs-xs"
                                    onMouseDown={() => handleSelectPlace(opt)}
                                  >
                                    <div>
                                      <strong className="fs-6">
                                        {opt.text2}
                                      </strong>
                                      <br />
                                      <small className="text-muted fs-7">
                                        {opt.text3}
                                      </small>
                                    </div>
                                  </li>
                                ))}
                              </div>
                            )}
                          </Col>
                        </Row>

                        <Row className="g-3 w-100">
                          <Col md={6}>
                            {renderInput("latitude", "Latitude")}
                          </Col>
                          <Col md={6}>
                            {renderInput("longitude", "Longitude")}
                          </Col>
                          <Col md={6}>{renderInput("state", "State")}</Col>
                          {/* </Row>
                        <Row className="g-3 w-100"> */}
                          <Col md={6}>{renderInput("city", "City")}</Col>
                          <Col md={6}>
                            {renderInput("district", "District")}
                          </Col>
                          <Col md={6}>{renderInput("pincode", "Pin Code")}</Col>
                        </Row>
                        <div className="mt-4">
                          <p className="text-muted small mb-3">
                            By clicking Sign Up, you agree to our{" "}
                            <span className="text-primary">Terms of Service</span>{" "}
                            and that you have read our{" "}
                            <span className="text-primary">Privacy Policy</span>.
                          </p>
                          <div className="form-check mb-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="smsConsent"
                              checked={smsConsent}
                              onChange={(e) => setSmsConsent(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="smsConsent">
                              I hereby authorize to send notifications on SMS/
                              Messages/Promotional /informational messages.
                            </label>
                          </div>
                          <button
                            className="btn btn-primary w-100"
                            type="submit"
                            disabled={loader && true}
                            color="primary"
                          >{loader && (
                              <Spinner size="sm" className="me-2">
                                {" "}
                                Loading...{" "}
                              </Spinner>
                            )}
                            Submit
                          </button>
                        </div>
                      </Form>
                      <OtpModal
                        isverified={showModal}
                        isOpen={isOpenState}
                        showmodal={showModal}
                        formik={formik}
                        setshowmodal={setShowModal}
                        toggle={toggle}
                        onVerify={onVerify}
                        isVerifying={busy}
                        error={error}
                        phoneMasked={`+91-${formik.values.phone}`}
                      />
                      <OtpSuccessModal
                        isOpen={showModal}
                        toggle={() => setShowModal(!showModal)}
                        handleRedirect={handleRedirect}
                      />
                      <GoogleMapModal
                        isOpen={mapModalOpen}
                        toggle={() => setMapModalOpen(false)}
                        validation={formik}
                        GOOGL_API_KEY={GOOGL_API_KEY}
                        addressInput={formik.values.address}
                        setSelected={setSelectedCoords}
                        setSelectedPlace={setSelectedPlace}
                        selected={selectedCoords}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default BasicSignUp;
